import { render, staticRenderFns } from "./myInfoPage.vue?vue&type=template&id=371f1af1&scoped=true&"
import script from "./myInfoPage.vue?vue&type=script&lang=js&"
export * from "./myInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./myInfoPage.vue?vue&type=style&index=0&id=371f1af1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f1af1",
  null
  
)

export default component.exports